type FeatureMap = {
  messaging: boolean;
};

const defaults: FeatureMap = {
  // Messaging/communication (inbox, threads, routes)
  messaging: false,
};

// Allow a JSON map via REACT_APP_FEATURE_FLAGS (e.g. '{"messaging":false}')
const raw = process.env.REACT_APP_FEATURE_FLAGS;
let parsed: Partial<FeatureMap> = {};
try {
  if (raw) parsed = JSON.parse(raw);
} catch {
  // ignore malformed input, fallback to defaults/other envs
}

// Allow specific env overrides per flag as well
const envOverrides: Partial<FeatureMap> = {};
if (process.env.REACT_APP_MESSAGING_ENABLED !== undefined) {
  envOverrides.messaging = String(process.env.REACT_APP_MESSAGING_ENABLED).toLowerCase() === 'true';
}

export const featureFlags: FeatureMap = {
  ...defaults,
  ...parsed,
  ...envOverrides,
};

export const isFeatureEnabled = (key: keyof FeatureMap) => featureFlags[key];
